const ifUndef = <T>(value: T | undefined | null, defaultValue: T) =>
  value === undefined || value === null ? defaultValue : value;

export default ifUndef;
